<template>
  <div>
    <nav-com  :flag='flag'></nav-com>
    <Authenticate></Authenticate>
    <foot-com class="foots"></foot-com>
  </div>
</template>

<script>
import NavCom from '../common/navs'
import FootCom from '../common/foots'
import Authenticate from './authuser'
export default {
  name: 'modify',
  components: {
    NavCom,
    FootCom,
    Authenticate,
  },
  data() {
    return {
      flag:false
    }
  },
}
</script>

<style lang="scss" scoped></style>
